module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/start.svg?efcd09b5eea42abc94abf19efe4bcd48";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/start.svg
// module id = 15
// module chunks = 0